import { useEffect } from "react";
import { setSeo } from "@/utils/seo";
import { Link } from "react-router-dom";
import { Navbar, Footer } from "@/components/Layout";

export default function CookiePolicy() {
  useEffect(() => {
    setSeo(
      "Cookie Policy | HairHelp",
      "Cookie Policy di HairHelp: utilizziamo solo cookie tecnici necessari al funzionamento, senza cookie di profilazione o pubblicitari."
    );
  }, []);

  return (
    <div className="min-h-screen bg-ivory font-manrope text-charcoal">
      <Navbar />
      <section className="mx-auto max-w-3xl px-6 py-16 md:py-24" data-testid="cookie-page">
        <h1 className="font-editorial text-3xl font-semibold text-foreground sm:text-4xl" data-testid="cookie-title">
          Cookie Policy
        </h1>
        <div className="mt-8 space-y-6 text-base leading-relaxed text-muted-foreground">
          <p>
            Questa Cookie Policy descrive come HairHelp utilizza i cookie e le tecnologie simili
            durante la navigazione sul sito.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Cosa sono i cookie</h2>
          <p>
            I cookie sono piccoli file di testo che i siti salvano sul dispositivo dell'utente per
            garantirne il corretto funzionamento e per raccogliere informazioni sull'utilizzo.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Cookie che utilizziamo</h2>
          <p>
            HairHelp utilizza cookie tecnici necessari al funzionamento del sito, incluso il cookie
            che consente l'accesso all'area riservata di amministrazione. Questi cookie sono
            indispensabili e non richiedono consenso.
          </p>
          <p>
            Il sito può inoltre avvalersi di strumenti di analisi statistica per comprendere, in
            forma aggregata, l'utilizzo delle pagine. Tali strumenti non vengono utilizzati per
            profilazione a fini pubblicitari.
          </p>
          <p>
            Non utilizziamo cookie di profilazione né cookie di terze parti a scopo pubblicitario o
            di marketing.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Gestione dei cookie</h2>
          <p>
            Puoi gestire o disabilitare i cookie in qualsiasi momento tramite le impostazioni del
            tuo browser. La disattivazione dei cookie tecnici potrebbe compromettere alcune
            funzionalità del sito.
          </p>
        </div>
        <Link
          to="/fai-una-domanda"
          data-testid="cookie-cta"
          className="mt-10 inline-block rounded-full bg-sage px-6 py-3 text-sm font-semibold text-white transition-transform duration-300 ease-out hover:scale-105 active:scale-95"
        >
          Chiedici un consiglio →
        </Link>
      </section>
      <Footer />
    </div>
  );
}
